import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';
import { hasIdentificationTag } from './utils/taxonGroups';

/** The option's key, in the URL too: /?sort=missingSpecies. */
const MISSING_SPECIES = 'missingSpecies';

/**
 * Where the option makes sense: the home page, and the forums with an
 * identification forum among them or their sub-forums ("Champignons" for
 * "Détermination de champignons") - not "Cuisine", where it could only
 * ever list nothing. A tag still loading keeps it: the server's filter
 * gives the right list either way.
 */
function offeredHere() {
  if (!m.route.param('tags')) return true;
  const tag = app.currentTag?.();
  if (!tag) return true;
  return [tag, ...(tag.children() || [])].some(t => !!t && hasIdentificationTag([t]));
}

/**
 * "En attente de détermination" in the discussion list's "Dernières
 * activités" dropdown: only the discussions of an identification forum
 * with no species decision yet - the same ones as the moderators'
 * /missing-species page (MissingSpeciesService), here for everyone. The one
 * nobody has touched for longest first (Jplm, 2026-11-02, as on phpBB):
 * replying to it sends it to the end of the list, and the next most buried
 * one comes up top. Each row shows that last intervention, core's default.
 *
 * A sort entry rather than a separate control, as asked: the dropdown is
 * the list's one choice of "which discussions". The server knows nothing
 * of it, so the entry stands for that order plus
 * filter[missingSpecies] (MissingSpeciesFilter). Only on the home and
 * forum pages' list (app.discussions), not on a species page's own.
 */
export default function addMissingSpeciesSort() {
  extend(DiscussionListState.prototype, 'sortMap', function (map) {
    if (this !== app.discussions || !offeredHere()) return;
    map[MISSING_SPECIES] = {
      sort: 'lastPostedAt',
      label: app.translator.trans('champis-species.forum.index_sort.missing_species_button')
    };
  });
  extend(DiscussionListState.prototype, 'requestParams', function (params) {
    // Where it isn't offered, a ?sort=missingSpecies left in the URL is
    // ignored, like any unknown sort: the list matches the dropdown.
    if (this !== app.discussions || this.getSort() !== MISSING_SPECIES || !(MISSING_SPECIES in this.sortMap())) return;
    params.filter = {
      ...params.filter,
      missingSpecies: '1'
    };
  });

  // On a page load, the server preloads the list it knows - unfiltered:
  // dropped, so that the list is fetched with the filter.
  override(IndexPage.prototype, 'oninit', function (original, vnode) {
    if (m.route.param('sort') === MISSING_SPECIES) app.preloadedApiDocument();
    original(vnode);
  });
}